import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import Switch from 'react-switch';


@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class SwitcherComponent extends Component{

  @observable trans = {

  };

  @observable checked = false;

  constructor(props) {

    super(props);

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

  }

  render() {

    const t = this.t;
    const onColor = '#4bccc0';
    const onHandleColor='#fff';

    return (
      <div className="SwitcherComponent">
          <Switch
            onColor={onColor}
            onHandleColor={onHandleColor}
            offColor={onHandleColor}
            handleDiameter={26}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 3px rgba(0, 0, 0, 0.2)"
            height={28}
            width={48}
            {...this.props}
          />
          <label>{ this.props.checked ? t('On') : t('Off') }</label>
      </div>
    );

  }
}


